<div class="content-container my-order">
	<section class="data-table">
		<!-- <header class="data-table__header">
			<h2 class="page-heading">
				<svg width="42" height="38" viewBox="0 0 42 38">
					<g class="fill-none" fill-rule="evenodd" stroke="#0CC5D1" stroke-width="2">
						<path stroke-linecap="square" d="M5.455 19L5.455 35.364 34.545 35.364 34.545 19M5.455 0L0 9.09c-.006 2.525 1.726 4.722 4.182 5.306 2.456.583 4.99-.6 6.122-2.856.914 1.841 2.792 3.006 4.848 3.006S19.086 13.38 20 11.54c.914 1.841 2.792 3.006 4.848 3.006s3.934-1.165 4.848-3.006c1.131 2.257 3.666 3.44 6.122 2.856 2.456-.584 4.188-2.78 4.182-5.305L34.545 0H5.455z" transform="translate(1 1)"/>
						<path d="M16.364 35.364L16.364 24.455 23.636 24.455 23.636 35.364" transform="translate(1 1)"/>
					</g>
				</svg>
				<ng-container i18n="@@orders.my_order">My Order</ng-container>
			</h2>
		</header> -->

		<div class="data-table__wrap">
			<header class="data-table__controls">
				<!-- <div class="back-icon" [ngClass]="{'active': selectedOrder}">
					<a (click)="goBackToListing()" href="javascript:void(0)" id="go-back" class="tu-btn-circular transparent"><i></i></a>
				</div> -->
				<!-- <div class="select-date-from catalogue-orders__filter select-pages" [ngClass]="{'hide-visible': selectedOrder}">
					<div class="catalogue-orders__filterSearchBox">
						<select nice-select class="select-link" id="tab-links-select" (change)="onChangeOrderTypeFilter($event.target.value)">
							<option [value]="'all'" [selected]="selectedOrderType == 'all'" i18n="@@orders.all_orders">All ({{ stats.all_orders_count }})</option>
							<option [value]="'pickup'" [selected]="selectedOrderType == 'pickup'" i18n="@@orders.pickup_orders">Pickup Orders ({{ stats.pickup_orders_count }})</option>
							<option [value]="'delivery'" [selected]="selectedOrderType == 'delivery'" i18n="@@orders.delivery_orders">Delivery Orders ({{ stats.delivery_orders_count }})</option>
						</select>
						<ul class="nav nav-pills" id="pills-tab" role="tablist">
							<li class="nav-item">
								<a class="nav-link active" id="pills-all-pill" data-toggle="pill" href="#pills-all-order" role="tab" aria-controls="pills-all-order" aria-selected="false" (click)="onChangeOrderTypeFilter('pickup')" i18n="@@orders.pickup_orders">{{ stats.all_orders_count }}</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" id="pills-cake-pill" data-toggle="pill" href="#pills-cake-store" role="tab" aria-controls="pills-cake-store" aria-selected="false" (click)="onChangeOrderTypeFilter('pick')" i18n="@@orders.pickup_orders">{{ stats.pickup_orders_count }}</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" id="pills-sweet-pill" data-toggle="pill" href="#pills-sweet-store" role="tab" aria-controls="pills-sweet-store" aria-selected="false" (click)="onChangeOrderTypeFilter('delivery')" i18n="@@orders.delivery_orders">{{ stats.delivery_orders_count }}</a>
							</li>
						</ul>
					</div>

					<div class="catalogue-orders__filterSearch">
						<div class="date-from">
							<div class="date-input-wrap">
								<input type="text" date-dropper [(ngModel)]="fromDate" (onDatePicked)="filterByDate()" data-dd-init-set="false" i18n-placeholder="@@ts.from_date" placeholder="From Date" class="date-input" data-dd-format="d/m/Y" data-dd-roundtrip="quote-date-range" />
							</div>

							<div class="date-input-wrap">
								<input type="text" date-dropper [(ngModel)]="toDate" (onDatePicked)="filterByDate()" data-dd-init-set="false" i18n-placeholder="@@ts.to_date" placeholder="To Date" class="date-input" data-dd-format="d/m/Y" data-dd-roundtrip="quote-date-range" />
							</div>
						</div>
						<button (click)="resetDateFilters()" class="tu-btn pink clear_btn" i18n="@@common.clear">Clear</button>
					</div>
				</div> -->


				<!-- <div class="data-table__btn-wrap">
					<div class="btn-row" [hidden]="selectedOrder">
						<form class="data-table__search" [class.open]="isSearch">
							<input type="text" (keyup)="searchOrders($event.target.value)" name="data-table__search--input" i18n-placeholder="@@input.search_here" placeholder="Type Search Here" #searchInput />
							<a href="javascript:void(0)" id="search-open" (click)="toggleSearch()">
								<svg width="20" height="19" viewBox="0 0 20 19">
								<g class="svg-stroke" fill="none" fill-rule="evenodd" stroke-width="1.5" transform="translate(1 1)">
									<circle cx="7" cy="7" r="7" />
									<path stroke-linecap="square" d="M13.5 12.5L18 17" />
								</g>
								</svg>
							</a>
							<svg id="search-close" width="15" height="15" class="close-icon" version="1.1" x="0px" y="0px" viewBox="0 0 14 14" style="enable-background:new 0 0 14 14;" xml:space="preserve" (click)="toggleSearch()">
								<path class="svg-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5" />
							</svg>
						</form>
					</div>
				</div> -->
			</header>

			<!-- <order-detail
				*ngIf="selectedOrder"
				[order]="selectedOrder">
			</order-detail>  -->

			<!-- <div *ngIf="!selectedOrder" class="tab-content data-table__tab-content" id="pills-tabContent">
				<div class="fade show active" id="pills-all-order" role="tabpanel" aria-labelledby="pills-all-order-tab">
					<ng-container *ngIf="orders && orders.length > 0; else noRecord">
						<order-list
							[orders]="orders"
							[paginator]="paginator"
							(onPageChange)="getPage($event)"
							(onViewOrder)="onViewOrder($event)"
							(orderAction) = "orderAction($event)"
							(updateOrderStatuses)="updateOrderStatuses($event)">
						</order-list>
					</ng-container>

					<ng-template #noRecord>
						<div class="tab-content data-table__tab-content">
							<ng-container *ngIf="loading; else noRecord" i18n="@@common.loading">Loading...</ng-container>
							<ng-template #noRecord>
								<ng-container i18n="@@common.no_record_found">No record found.</ng-container>
							</ng-template>
						</div>
					</ng-template>
				</div>
			</div> -->


		</div>

	</section>
</div>

<div class="content-container my-order">
	<section class="data-table">

		<header class="data-table__header" *ngIf="!selectedOrder">
			<h2 class="page-heading tab-content-header active" id="all-orders-content-header">
				<ng-container i18n="@@orders.my_order">My Order</ng-container>
			</h2>
		</header>

		<div class="data-table__wrap">
			<header class="data-table__controls" *ngIf="!selectedOrder">
				<!-- <div class="back-icon">
                  <a href="#" id="go-back" class="tu-btn-circular transparent"><i></i></a>
              </div> -->
				<div class="select-date-from select-pages">
					<div class="select-pages_tabs">
						<ul class="tabs_content">
							<li class="tab_item" [class.active]="selectedOrderType =='all'" data-target="all-orders" (click)="onChangeOrderTypeFilter('all')" i18n="@@orders.all_orders">
								All ({{ stats.all_orders_count }})
							</li>
							<li class="tab_item" [class.active]="selectedOrderType =='pickup'" data-target="pickup" (click)="onChangeOrderTypeFilter('pickup')" i18n="@@orders.pickup_orders">
								Pickup ({{ stats.pickup_orders_count }})
							</li>
							<li class="tab_item" [class.active]="selectedOrderType =='delivery'" data-target="delivery" (click)="onChangeOrderTypeFilter('delivery')" i18n="@@orders.delivery_orders">
								Delivery ({{ stats.delivery_orders_count }})
							</li>
						</ul>
					</div>
				</div>

				<div class="filters_block">
					<svg class="search_icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path d="M21 21L17.5001 17.5M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z" stroke="#757575" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
					</svg>
					<input type="text" class="filters_search" (keyup)="searchOrders($event.target.value)" name="data-table__search--input" i18n-placeholder="@@input.search_here" placeholder="Type Search Here" #searchInput />
					<div class="filters_btn_wrap">
						<!-- <button class="clear_allfilters saved_filters">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                              <path d="M13.3333 4.99984V4.33317C13.3333 3.39975 13.3333 2.93304 13.1517 2.57652C12.9919 2.26292 12.7369 2.00795 12.4233 1.84816C12.0668 1.6665 11.6001 1.6665 10.6667 1.6665H9.33333C8.39991 1.6665 7.9332 1.6665 7.57668 1.84816C7.26308 2.00795 7.00811 2.26292 6.84832 2.57652C6.66667 2.93304 6.66667 3.39975 6.66667 4.33317V4.99984M2.5 4.99984H17.5M15.8333 4.99984V14.3332C15.8333 15.7333 15.8333 16.4334 15.5608 16.9681C15.3212 17.4386 14.9387 17.821 14.4683 18.0607C13.9335 18.3332 13.2335 18.3332 11.8333 18.3332H8.16667C6.76654 18.3332 6.06647 18.3332 5.53169 18.0607C5.06129 17.821 4.67883 17.4386 4.43915 16.9681C4.16667 16.4334 4.16667 15.7333 4.16667 14.3332V4.99984" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          Clear saved filters
                      </button> -->
						<button class="filters_block_btn filters_options" (click)="toggleFilters()">
							<svg class="static" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
								<path d="M6 12H18M3 6H21M9 18H15" stroke="#0A0A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
							<ng-container i18n="@@filter.filters">Filters</ng-container> <span class="selected_filters2"></span>
						</button>
						<button class="filters_block_btn filter_export" (click)="exportXls()">
							<svg class="static" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
								<path d="M21 3H3M18 13L12 7M12 7L6 13M12 7V21" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<span i18n="@@common.download_xls">download .xls</span>
						</button>
						<!-- <button class="filters_block_btn filter_export">
							<svg class="static" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
								<path d="M21 3H3M18 13L12 7M12 7L6 13M12 7V21" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							Export...
						</button> -->
					</div>
				</div>
				<div class="filters_expanded">
					<h3 class="filters_expanded_header"> <ng-container i18n="@@filter.filters">Filters</ng-container></h3>
					<!-- <div class="checkbox_cont">
                      <div class="custom-checkbox filters_checkbox">
                          <input id="filters_checkbox" type="checkbox" class="select-item orders_inputAll">
                          <svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
                          </svg>
                          <svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
                              <path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                      </div>
                      <span>Remember for the next time</span>
                  </div> -->
					<div class="filters_expanded_bottom order-listing">
						<div class="date_wrap">
							<span class="date_title" i18n="@@ts.date">Creation Date</span>
							<div class="field_cont">
								<label i18n="@@filter.from">from</label>
								<fieldset class="date sl">
									<div class="date-input-wrap">
										<input type="text" date-dropper [(ngModel)]="fromDate" (onDatePicked)="filterByDate()" i18n-placeholder="@@common.from_date" placeholder="From Date" class="date-input" data-dd-init-set="false" data-dd-format="d/m/Y" data-dd-roundtrip="order-date-range" />
									</div>
								</fieldset>
								<label i18n="@@filter.to">to</label>
								<fieldset class="date sl">
									<div class="date-input-wrap">
										<input type="text" date-dropper [(ngModel)]="toDate" (onDatePicked)="filterByDate()" i18n-placeholder="@@common.to_date" placeholder="To Date" class="date-input" data-dd-init-set="false" data-dd-format="d/m/Y" data-dd-roundtrip="order-date-range" />
									</div>
								</fieldset>
							</div>
						</div>
						<div class="status_wrap">
							<span class="date_title" i18n="@@orders.status">Status</span>
							<div class="multiselect-container1" (click)="toggleSelectMenu();">
								<!-- <select id="multiselect" class="multiselect d-none" multiple >
									<option value="new" data-status="new">New</option>
									<option value="preparing" data-status="preparing">Preparing</option>
									<option value="completed" data-status="complete">Complete</option>
									<option value="declined" data-status="declined">Declined</option>
									<option value="canceled" data-status="canceled">Canceled</option>
								</select>
								<div class="selected-options"></div>
								<svg class="add-option" xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
									<path d="M12.6666 5V19M5.66663 12H19.6666" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								</svg> -->
								<fieldset class="md">
									<select nice-select i18n-data-placeholder="@@option.select_status" data-placeholder="Select Status" class="nice-select" [(ngModel)]="order_status" (change)="filterByStatus()">
										<option value="" i18n="@@option.select_status">Select Status</option>
										<option value="pending" data-status="pending">Pending</option>
										<option value="scheduled" data-status="scheduled">Scheduled</option>
										<option value="preparing" data-status="preparing">Preparing</option>
										<option value="ready_to_pickup" data-status="ready_to_pickup">Ready to pickup</option>
										<option value="picked_up" data-status="picked_up">Picked up</option>
										<option value="out_for_delivery" data-status="out_for_delivery">Out for delivery</option>
										<option value="completed" data-status="completed">Complete</option>
										<option value="converted_to_invoice" data-status="converted_to_invoice">Converted to invoice</option>
										<option value="converted_to_quotation" data-status="converted_to_quotation">Converted to quotation</option>
										<option value="declined" data-status="declined">Declined</option>
										<option value="canceled" data-status="canceled">Canceled</option>
										<option value="rejected" data-status="rejected">Rejected</option>
									</select>
								</fieldset>
							</div>
						</div>
						<div class="total_wrap">
							<span class="date_title" i18n="@@orders.total">Total</span>
							<div class="total_cont">
								<label i18n="@@filter.from">from</label>
								<input type="number" appPreventScroll [(ngModel)]="minAmount" (keyup)="filterByAmount()" placeholder="1,00">
								<label i18n="@@filter.from">to</label>
								<input type="number" appPreventScroll [(ngModel)]="maxAmount" (keyup)="filterByAmount()" placeholder="1,00">
							</div>
						</div>
						<div class="date_wrap">
							<span class="date_title" i18n="@@ts.date">Due Date</span>
							<div class="field_cont">
								<label i18n="@@filter.from">from</label>
								<fieldset class="date sl">
									<div class="date-input-wrap">
										<input type="text" date-dropper [(ngModel)]="fromDueDate" (onDatePicked)="filterByDueDate()" i18n-placeholder="@@common.from_date" placeholder="From Date" class="date-input" data-dd-format="d/m/Y" data-dd-roundtrip="date-range" />
									</div>
								</fieldset>
								<label i18n="@@filter.to">to</label>
								<fieldset class="date sl">
									<div class="date-input-wrap">
										<input type="text" date-dropper [(ngModel)]="toDueDate" (onDatePicked)="filterByDueDate()" i18n-placeholder="@@common.to_date" placeholder="To Date" class="date-input" data-dd-format="d/m/Y" data-dd-roundtrip="date-range" />
									</div>
								</fieldset>
							</div>
						</div>
						<button class="clear_allfilters" (click)="clearAllFilter()">
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
								<path d="M13.3333 4.99984V4.33317C13.3333 3.39975 13.3333 2.93304 13.1517 2.57652C12.9919 2.26292 12.7369 2.00795 12.4233 1.84816C12.0668 1.6665 11.6001 1.6665 10.6667 1.6665H9.33333C8.39991 1.6665 7.9332 1.6665 7.57668 1.84816C7.26308 2.00795 7.00811 2.26292 6.84832 2.57652C6.66667 2.93304 6.66667 3.39975 6.66667 4.33317V4.99984M2.5 4.99984H17.5M15.8333 4.99984V14.3332C15.8333 15.7333 15.8333 16.4334 15.5608 16.9681C15.3212 17.4386 14.9387 17.821 14.4683 18.0607C13.9335 18.3332 13.2335 18.3332 11.8333 18.3332H8.16667C6.76654 18.3332 6.06647 18.3332 5.53169 18.0607C5.06129 17.821 4.67883 17.4386 4.43915 16.9681C4.16667 16.4334 4.16667 15.7333 4.16667 14.3332V4.99984" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
							Clear all
						</button>
					</div>
				</div>
			</header>

			<div class="tab-content data-table__tab-content" id="pills-tabContent">
				<div class="tab-pane fade show active" id="all-orders-content" role="tabpanel" aria-labelledby="pills-all-order-tab">
					<ng-container *ngIf="orders.length; else noOrder">
						<div id="order_content" style="width: 100%" *ngIf="selectedOrder">
							<order-detail
								[order]="selectedOrder"
								(selectedOrder)="goBackToListing()"
								(orderAction)="orderAction($event)"
								(updateOrderStatuses)="updateOrderStatuses($event)">
							</order-detail>
						</div>
						<div id="all_orders_table" style="width: 100%" *ngIf="!selectedOrder">
							<new-order-list
								[orders]="orders"
								[paginator]="paginator"
								(perPageItems)="onChangePerPageItems($event)"
								(onPageChange)="getPage($event)"
								(onViewOrder)="onViewOrder($event)"
								(orderAction)="orderAction($event)"
								(updateOrderStatuses)="updateOrderStatuses($event)"
								(sortRequested)="fetchOrders($event.column, $event.direction)">
							</new-order-list>
						</div>
					</ng-container>
					<ng-template #noOrder>
						<ng-container *ngIf="!orders.length">
							<img class="emty_img" src="./images/icons/no-content-backup.png" alt="No order" loading="lazy">
							<h2 class="empty_orders" i18n="@@orders.you_dont_have_any_orders">You don’t have any orders yet</h2>
						</ng-container>
					</ng-template>
				</div>
			</div>
		</div><!-- end data-table__wrap -->

	</section><!-- end data-table -->
</div>

<app-scheduled 
	[scheduleOrders]="scheduleOrders"
	[remindOrders]="remindOrders"
	(onViewOrder)="onViewOrder($event)" 
	(orderAction)="orderAction($event)"
></app-scheduled>